import { gql } from "@apollo/client";
export default gql`
  query GetEdiLink {
    getEdiLink {
      data
    }
  }
`;
